import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>ச்ராத்தம் சில விளக்கங்கள்</h1>
<div class="color5">
  இந்த ச்ராத்தம் என்ற பகுதியில் என்னென்ன விஷயங்கள் இடம்பெற்றுள்ளன என்பதற்கான பட்டியலும் அவை பற்றிய சிறு குறிப்புகளும் இங்கே வழங்கப்படுகின்றன. குறிப்புகளைக்கொண்டு அந்தப் பக்த்தை பார்வையிடவேண்டுமா அல்லது பிறகு பார்த்துக்கொள்ளலாமா என தீர்மானிக்க உதவியாக இருக்கும். மேலும் அந்தப்பக்கம் மேம்படுத்தப்பட்டுள்ளதா என்ற தகவலும் இந்த பக்கத்தில் வெளியிடப்படும்.
  "அக்நிசந்தானம்"
  "சாஸ்த்ரம்"
  "ச்ராத்த திதி"
  "ச்ராத்த வகைகள்"
  "பித்ரு பட்டியல்"
  "ச்ராத்தம் ஏன் பண்ணவேண்டும்?"
  "ச்ராத்தம் யஜூா்"
  "ச்ராத்தம்-ஸாமம்"
  "கயா ச்ராத்தம்"
  "தர்பணம்-யஜூா்"
  "தர்பணம்-ஸாமம்"
  "அமாவாஸை-மஹாளயம்"
  "மஹாளயம்"
  "க்ரஹண தர்பணம்"
  "கேள்வி-பதில்"
</div>
<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      அக்நிசந்தானம்
    </mat-expansion-panel-header>
    <div class="div3">
      ஸ்ரீ:<br>
      அக்நிசந்தானம் ஔபாஸனம் ச்ராத்தத்தின் ஒரு முக்கியமான அம்சமாகும்.
      <br> அநுஷ்டானம் என்ற பகுதியில் 5 மற்றும் 6 வது மெனுவாகிய 
      அக்னிஸந்தானம் மற்றும் ஔபாஸனத்தை  உபயோகிக்கவும். 
  
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      சாஸ்த்ரம்
    </mat-expansion-panel-header>
    <div class="div3">
      தர்பணம் முதலானவை பற்றி தர்மாசாஸ்த்ர சுருக்கத்தில் கண்டுள்ளபடி...<hr> 
      பிதா இறந்து ஒரு வர்ஷ காலத்திற்குப் பிறகு திலதர்ப்பணம் செய்யவேண்டும் 
      என்றும், க்ரஹணம் முதலிய நைமித்திகம் நேர்ந்தால் அது முதற்கொண்டு 
      செய்யவேண்டுமென்றும், ஒரு வர்ஷம் க்ரமித்துத் தான் ப்ரேதத்வம் 
      நீங்குகிறதென்றும் சிலர் சொல்லுகிறார்கள். அது ஸரியல்ல.<hr>
       ஏனெனில், ஸபிண்டீகரணத்திற்குப் பிறகு செய்யப்படும் ஸோதகும்பம், 
       மாஸிகம், இவைகளை பித்ருத்வம் வந்து விட்டதென்ற ந்யாயத்தைக்கொண்டு
        பார்வணமாகச் செய்கிறார்கள்.<hr> திலதர்ப்பணத்திற்கு மட்டில் 
        பித்ருத்வம் வரவில்லை என்று நினைப்பது தகுதியாகுமா? <hr>
        அன்றியும் தகப்பனிறந்து ஸபிண்டீகரணம் ஆனபிறகு 
        ஒரு வர்ஷத்துக்குள் தாயார் ச்ராத்தம் வந்தால் 
        அதற்கு அங்கமான பரேஹநி தர்ப்பணத்தை செய்கிறதா விட்டுவிடுகிறதா?<hr>
         இதற்கு பதில் அவர்களே தான் சொல்லவேண்டும்.<hr>
          தர்சமும், ஸங்க்ரமணமும் ஒன்று சேர்ந்தால் ஏதாவதொன்றை அனுஷ்டிக்கலாம் என்று சிலர்.<hr>
தர்சத்தில் (அமாவாசையில்) எந்த ஸங்க்ரமணம் (மாதப்பிறப்பு) நேர்ந்தாலும், 
ஸங்க்ரமணத்தையே அநுஷ்டிக்கவேண்டும், ஸங்க்ரமணம் நைமித்திகம் ஆனதால் 
என்பது சிலர் மதம்.<hr>
தர்சம், ஸங்க்ரமணம், அர்த்தோதயம், அல்லது மஹோதயம் இவைகள் சேர்ந்தால் 
அர்தோதயம் அல்லது மஹோதயத்தை அநுஷ்டிக்கவேண்டியது.<hr>
 (விளக்கம்)
தர்சத்தில் க்ரஹணம் சேரும்போது க்ரஹணத்தை அநுஷ்டிக்கவேண்டியது.<hr>
பிதா மாதா இறந்துபோன வர்ஷத்தில் தர்ச ச்ராத்தம் முதலியவைகளைஅன்ன ரூபமாக செய்யவே கூடாது.<hr>
ஸபிண்டீகரணத்திற்குப் பிறகு திலதர்ப்பணத்தை மட்டும் செய்யவேண்டும்.<hr> வேண்டாமென்பது சிலர் கொள்கை.<hr>
அவிபக்தர்களான ப்ராதாக்கள், தர்சம் முதலிய ச்ராத்த தினங்களில் வெவ்வேரிடங்களிலிருந்தால் 
தனித்தனியே ச்ராத்த தர்ப்பணாதிகளைச் செய்யவேண்டியது.<hr>
தர்ச ச்ராத்தத்தில் ஸ்த்ரீகளுக்கு வரணம் கிடையாது. பித்ரு வரணத்துடன் சேர்த்தும் செய்யக்கூடாது.
<hr> ஆனால் தர்ப்பணமும் பிண்டமும் உண்டு.<hr>
தகப்பன் உள்ளவனுக்கு பித்ருகார்யங்களில் அதிகாரமில்லை.<hr>
 ஆனால் ‘பித்ருயக்ஞம்’, நாந்தீ, தீர்த்தச்ராத்தம் இவைகளை தகப்பன் உள்ளவனும் செய்யவேண்டியது.<hr>
தகப்பன் செய்தால் யார் தேவதைகளோ அவர்களே இவனுக்கும் தேவதைகள்.<hr>
 தீர்த்த ச்ராத்தத்தில் கயா ச்ராத்தம் கிடையாது.<hr>
ஆள்காட்டிவிரலையும் கட்டைவிரலையும் சேர்த்து எள்ளை எடுக்கக்கூடாது.<hr>
 கட்டைவிரலாலேயே தள்ளிக்கொள்ளவேண்டியது.<hr>
ஸங்கல்பச்ராத்தத்தில் ;ஆவாஹனம், ஹோமம், அர்க்யம், விகிரம், பிண்டப்ரதானம் இவைகள் கிடையாது.<hr>
1. அமாவாஸ்யை. 2. போதாயன அமாவாஸ்யை.<hr>
 போதாயன அமாவாஸ்யை என்பது போதாயன ஸூத்ரிகளாலும், காத்யாயன ஸூத்ரிகளாலும் 
 அனுஷ்டிக்கப்பட்டுவருகிறது.<hr>
இந்த போதாயன அமாவாஸ்யைக்கு சந்த்ர தர்சனம் முக்யம்.<hr>
 போதாயன அமாவாஸ்யை கழித்த மறு நாளைக்கு மறுநாள் சந்த்ரதர்சனம் ஆகவேண்டியது.<hr>
ஒரு ஸ்த்ரீயின் பர்த்தாவுக்கு தன் ஒளரஸ புத்ரனோ, ஸவீக்ருதபுத்ரனோ, 
அல்லது ஸபத்நீபுத்ரன் வகையராவோ ச்ராத்தம் செய்யும் காலத்தில், 
இவள் அவர்களின் அருகில் இருக்கவேண்டியது.<hr>
 அப்படி இல்லாவிட்டால்.  இவளும் பர்த்தாவை உத்தேசித்து தனிமையில் ச்ராத்தம் செய்யவேண்டியது. <hr>
 அப்படிச் செய்யாவிட்டால் ச்ராத்தத்தை விட்டவனுக்கு என்ன தோஷப்ராயச்சித்தம் ஏற்படுகிறதோ 
 அதற்கு இவளும் உள்ளாகிறாள்.<hr>
<span class="title3">மஹாளயம்.</span>
மஹாளயத்தில் பரணிக்கு ‘மஹாபரணீ “ என்று பெயர்.<hr>
 த்ரயோதசிக்கு, ‘கஜச்சாயை” என்று பெயர்.<hr>
  மத்யாஷ்டமிக்கு ‘கயை” எனப்பெயர்.<hr>
   இவைகளிற் செய்யும் ச்ராத்தம், கயா ச்ராத்தத்திற்கு ஸமானம்.<hr>
    அமாவஸ்யை, வ்யதீபாதம், பரணீ, த்வாதசீ, அஷ்டமி இவைகளில் 
    திதி, நக்ஷத்ரம், வாரம் இவைகளால் ஏற்பட்ட தோஷங்களைக் கவனிக்கவேண்டியதில்லை. 
    மஹாளயபக்ஷத்தைத் தவிர, மற்ற பக்ஷங்களில் ப்ரதமை, ஷஷ்டி, ஏகாதசி, 
    த்ரயோதசி, ஜன்மநக்ஷத்ரம், ரோஹிணீ, ரேவதீ, மகம் இவைகளில் மஹாளயம் கூடாது.<hr> 
    ஏகவர்க்கத்திற்கு மஹாளயம் செய்யும் விஷயத்தில், த்ரயோதசீ, மகம் இவைகள் கூடாது. <hr>
    இரண்டு வர்க்கத்திற்கும் செய்கிற மஹாளயத்தில் த்ரயோதசீ, மகம் மெத்த ச்லாக்யம்<hr>
     பிள்ளைகள் பிரித்துக்கொண்டாலும், ஒன்றாக இருந்தாலும்,
      ப்ரத்யேகமாய்த்தான் மஹாளயம் செய்யவேண்டியது.<hr>
       பிரித்துக்கொள்ளாத காலத்தில், மகத்துடன் சேர்ந்த திரயோதசியில் செய்யக்கூடாது.<hr>
        இந்த மகா த்ரயோதசியில் பிண்டதானம் கிடையாது.<hr>
         இரண்டு அயனங்களிலும், 2 விஷுவங்களிலும், எல்லாயுகாதிகளிலும் பிண்டதானத்தைத் தவிர, 
         ச்ராத்தம் செய்யவேண்டும்.<hr> மகாநக்ஷத்ரத்தில் பிண்டப்ரதானம் கூடாது. 
         <hr>அந்வஷ்டகை, வ்ருத்தி, மஹாளயம், ப்ரத்யாப்திகம், கயை இவைகளில் 
         மாதாவுக்குத் தனியாக வரணமுண்டு.<hr>
         <span class="title3">காருணிக பித்ருக்களாவன:--
          </span> 
          சிறிய தகப்பன், பெரிய தகப்பன், தமையன், தம்பி, பிள்ளைகள், அத்தை, 
          அம்மான், பெரியதாயார், சிறியதாயார், ஸஹோதரிகள், 
          தங்கை தமக்கைகளின் புத்ரர்கள், பார்யை, மாமனார், அத்திம்பேர், மாட்டுப்பெண், 
          மைத்துனன், குரு, யஜமானன், ஸ்நேகிதன் இவர்களுக்கும் மஹாளயத்தில் ச்ராத்தம் செய்யவேண்டும். 
          <hr>பிள்ளையுள்ள சிறிய தகப்பனுக்கு வேண்டியதவச்யமில்லை.<hr>
           மஹாளயச்ராத்தத்தை அன்னரூபமாய் செய்கிறவர்களும், ஹிரண்யரூபமாய் செய்கிறவர்களும், 
           ப்ரதிவர்ஷமும் அவ்விதமே செய்யவேண்டுமென்ற நியமமில்லை.<hr>
            தேச காலசக்த்யனுஸாரமாய் மாரிச்செய்வதால் தோஷமில்லை.<hr>
             விதுரர்கள் மஹாளத்தை அன்னரூபமாய்ச் செய்ய அதிகாரமுள்ளவர்களல்ல.<hr>
              பர்வதினத்தில், ப்ரத்யாப்திகச்ராத்தம் க்ரஹணத்தால் நிஷேதிக்கப்பட்டு 
              மறுநாள் செய்யவேண்டிவரும் விஷயத்தில் பர்வதினத்தில் ப்ரத்யாப்திக ச்ராத்தத்தை 
              ஹிரண்ய ரூபமாய்ச் செய்யவேண்டியது.<hr> அதற்கங்கமாய் தர்ப்பணம் கிடையாது.
              <hr> மாதா ஜீவித்திருந்தால்; மஹாளயத்தில் மாத்ரு வர்க்கத்துக்கு வரணமில்லை. 
              ஸபத்நீமாதா ஜீவித்திருந்தாலும் பிதாமஹ்யாதிகளுக்கு வரணமில்லை.<hr>
               ஆனால் மாதாவோ அல்லது ஸபத்நீமாதாவோ இறந்துபோயிருந்தால் 
               அவர்களுக்கு மட்டில் வஸுரூபமாக வரணம் செய்யவேண்டுமென்று தோன்றுகிறது.<hr>
                இரண்டு பேரும் இறந்துபோயிருக்கும் பக்ஷத்தில் க்ரமப்படி மாத்ருவர்க்கத்திற்கும் 
                ஸபத்நீமாதாவுக்குத் தனியாகவும் வரணம் உண்டு.<hr>
                 சிலர் ஸபத்நீமாதாவை காருணிக பித்ருக்களில் சேர்த்து வரணம் செய்கிறார்கள். அது பிசகு.<hr>
                  அவள் மாதாவைப்போலவே தவிர, காருணிக பித்ருக்களில் சேரமாட்டாள்.<hr>
                   ஸன்யாஸியின் மஹாளயத்தை துவாதசியிலேயே செய்யவேண்டியது.<hr>
                    மற்ற திதிகளில் செய்யக்கூடாது.<hr> ஆனால் த்வாதசியில் ஸந்யாஸியல்லாத 
                    மற்றவர்களுக்கும் செய்யலாம்.
         </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      ச்ராத்த திதி
    </mat-expansion-panel-header>
    <div class="div3">
      இந்த வருடம் மற்றும் கடந்த வருடத்திற்கான ச்ராத்த திதிகள் பட்டியல். இந்த பக்கம் பஞ்சாங்கம் என்ற தலைப்பிலும் இடம்பெற்றுள்ளது. ச்ராத்த திதி ஸம்பந்தமாக ஏதேனும் ஸந்தேகம் இருந்தால் தொடர்புகொள்ளவும்.
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      ச்ராத்த வகைகள்
    </mat-expansion-panel-header>
    <div class="div3">
      ச்ராத்தங்கள் பல வகைப்படும்.
      1. நக்ன ச்ராத்தம்
      2. ஏகோத்ர வ்ருத்தி ச்ராத்தம்
      3. நவ ச்ராத்தம்
      4. ஏகோத்திஷ்ட ச்ராத்தம்
      5. ஷோடச ச்ராத்தம்
      6. ஸபிண்டீகரண ச்ராத்தம்
      7. ஸோதகும்ப ச்ராத்தம்
      8. ஊன மாஸிக ச்ராத்தம்
      9. திதி மாஸிக ச்ராத்தம்
      10. ஊன ஆப்தீக ச்ராத்தம்
      11. வருஷ ஆப்தீக ச்ராத்தம்
      12. ப்ரத்யாப்தீக ச்ராத்தம்
      13. மஹாளய ச்ராத்தம்
      14. தர்ச ச்ராத்தம்
      15. சங்க்ரமண புண்யகால ச்ராத்தம்
      16. க்ரஹணாதி புண்யகால ச்ராத்தம்
      17. அஷ்டகா ச்ராத்தம்
      18. அந்வஷ்டகா ச்ராத்தம்
      19. யுகாதி, மந்வாதி புண்யகால ச்ராத்தம்
      20. நாந்தி ச்ராத்தம்
      21. ஷண்ணவதி ச்ராத்தம்
      
      முதல் ஆறு விஷயங்கள் அபரத்தில் சேர்ந்தவை. 
      இவை ப்ரேத ரூபமாக இருக்கும் ஒருவரை உத்தேசித்துச் 
      செய்யப்படுபவை ஆகும். 
      இவைகளைச் செய்வதற்கான 
      விதிகள் மிகவும் வேறுபடும். 
      மற்றவை அனைத்தும் குறைந்தது 3 தலைமுறை பித்ருக்களை
      உத்தேசித்து செய்யப்படுபவை ஆகும். 

      மேற்கண்ட ச்ராத்தங்கள் வெவ்வேறு ரூபங்களில் பண்ணப்பட்டு வருகின்றன. அவையானவன
      1. தில தர்பண ரூபம்
      2. ஹிரண்ய ரூபம்
      3. ஆம ரூபம்
      4. ஸங்கல்ப ச்ராத்தம்
      5. பார்வண ச்ராத்தம்
      என்கிற ஐந்துவிதமாகப் பண்ணப்படுகிறது. ஒவ்வொன்றும் எப்படிச் செய்வது? எனப்பது பற்றிய விபரங்கள் தொடர்ந்து கீழே வழங்கப்படுகிறது.
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      பித்ரு பட்டியல்
    </mat-expansion-panel-header>
<div class="head2">
  தர்பணம் ச்ராத்தம் பண்ணும்போது 
  பித்ருக்களின் உறவைச் (
    அப்பா - தாத்தா - கொள்ளுத்தாத்தா 
    என்கிற உறவுமுறைக்கான சரியான ஸம்ஸ்க்ருதச் 
    சொல்லை உச்சரிக்கவேண்டும். 
  ) சரியாகச் சொல்லவேண்டும். 
  அவர்களுக்கான பெயரைச் சரியாகச் சொல்லாவிடினும் 
  இந்த உறவுமுறைப் பெயர்களைச் சரியாகச் சொன்னாலே
  அவர்களைச் சென்றடையும் என்பதை அறியவும். 
  இங்கு அனைத்துவித பித்ருக்களின் உறமுறைப் பெயர்களின் 
  பட்டியல் வழங்கப்பட்டுள்ளன.

</div>
    <div class="div3">
      <h2>பித்ருக்களின் பெயர்கள்</h2>
<img src="assets/img/pithru-names.JPG" />
<h2>பித்ரு வர்க்கம்</h2>
<img src="assets/img/pithru-vargam.JPG" />
<h2>மாத்ரு வர்க்கம்</h2>
<img src="assets/img/maathru-vargam.JPG" />
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      ச்ராத்தம் ஏன் பண்ணவேண்டும்?
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      ச்ராத்தம் யஜூா்
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      "ச்ராத்தம்-ஸாமம்
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      கயா ச்ராத்தம்
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      தர்பணம்-யஜூா்
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      தர்பணம்-ஸாமம்
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      அமாவாஸை
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      மஹாளயம்
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      க்ரஹண தர்பணம்
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      கேள்வி-பதில்
    </mat-expansion-panel-header>
    <div class="div3">

    </div>
  </mat-expansion-panel>
</mat-accordion>`;

const ShradhdhamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="சில விளக்கங்கள் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default ShradhdhamPage;
